const LOCAL_CMS_BASE_URL = 'http://localhost:1338'
const PROD_CMS_BASE_URL = 'https://gpu-audio-strapi-cms-gcv6e.ondigitalocean.app'

export const CMS_BASE_URL = process.env.NODE_ENV === 'development' ? LOCAL_CMS_BASE_URL : PROD_CMS_BASE_URL

const HOME_PAGE_QUERY_PARAMS = new URLSearchParams([
  ['populate[hero][fields][0]', 'pillText'],
  ['populate[hero][fields][1]', 'titleText'],
  ['populate[hero][fields][2]', 'description'],
  ['populate[hero][fields][3]', 'backgroundVideoUrl'],
  ['populate[hero][populate][backgroundImage][fields][0]', 'url'],
  ['populate[soundcore][fields][0]', 'text'],
  ['populate[soundcore][fields][1]', 'buttonText'],
  ['populate[soundcore][fields][2]', 'buttonUrl'],
  ['populate[soundcore][populate][logo][fields][0]', 'url'],
  ['populate[soundcore][populate][desktopBackground][fields][0]', 'url'],
  ['populate[soundcore][populate][mobileBackground][fields][0]', 'url'],
  ['populate[soundcore][populate][featureCards][fields][0]', 'text'],
  ['populate[soundcore][populate][featureCards][populate][icon][fields][0]', 'url'],
  ['populate[accelerationFeatureCards][fields][0]', 'title'],
  ['populate[accelerationFeatureCards][populate][icon][fields][0]', 'url'],
  ['populate[accelerationStatCard][fields][0]', 'body'],
  ['populate[accelerationStatCard][fields][1]', 'statPrefix'],
  ['populate[accelerationStatCard][fields][2]', 'statValue'],
  ['populate[accelerationStatCard][fields][3]', 'statSuffix'],
  ['populate[accelerationStatCard][populate][icon][fields][0]', 'url'],
  ['populate[soundscapeLogo][fields][0]', 'url'],
  ['populate[soundscapeDesktopBackground][fields][0]', 'url'],
  ['populate[soundscapeMobileBackground][fields][0]', 'url'],
  ['populate[soundscapeFeatureCards][fields][0]', 'text'],
  ['populate[soundscapeFeatureCards][populate][icon][fields][0]', 'url'],
  ['populate[partnerProgramPillItems][fields][0]', 'text'],
  ['populate[technologyBenefitsCards][fields][0]', 'title'],
  ['populate[technologyBenefitsCards][fields][1]', 'body'],
]).toString()

export const CMS_ENDPOINTS = {
  homePage: `/api/home-page?${HOME_PAGE_QUERY_PARAMS}`,
} as const

export const CMS_CACHE_CONFIG = {
  homePage: {
    key: 'gpua.home-page.cms.v1',
    version: 3,
    ttlMs: 10 * 60 * 1000,
  },
} as const
